import { EMPTY, of, concat } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports -----

import {
	uiActions, turnActions
} from '~/store';
import { TURN_START_NEXT } from '~/store/turn/actionTypes';
import { MAIN_SCREEN_MODALS } from '~/lib/constants';
// ---- internal imports ----

import displayFinancialStatementNotSubmittedPopup from './displayFinancialStatementNotSubmittedPopup';
import displayNextTurnConfirmation from './displayNextTurnConfirmation';
import displayMandatoryProfitDistributionPopup from './displayMandatoryProfitDistributionPopup';
// ---- local imports ----


// this triggers the next turn and the actions that follow it
const onStartNextTurnEpic = (action$, state$) => action$.pipe(
	ofType(TURN_START_NEXT),
	mergeMap((action) =>
		concat(
			runAll$(),
			runFirstMatchFromSequence$(state$.value, action.caller),
		)
	),
);

const runAll$ = () => of(uiActions.closeOpenedDraggables());

const runFirstMatchFromSequence$ = (state, actionCaller) => {
	for (const actionCreator of getActionCreators(actionCaller)) {
		const action = actionCreator(state);
		if (action) {
			return of(action);
		}
	}

	return EMPTY;
};

const getActionCreators = (caller) => {
	if (caller === MAIN_SCREEN_MODALS.NEXT_TURN_CONFIRMATION || caller === MAIN_SCREEN_MODALS.MISSOUT_CUSTOMERS) {
		return afterConfirmedNextTurnActionCreators;
	}

	if (caller === MAIN_SCREEN_MODALS.FINANCIAL_STATEMENTS_NOT_SUBMITTED_MODAL) {
		return afterConfirmedDistributeProfitActionCreators;
	}

	if (caller === MAIN_SCREEN_MODALS.MANDATORY_PROFIT_DISTRIBUTION_MODAL) {
		return afterConfirmedMandatoryProfitDistributionActionCreators;
	}

	return DEFAULT_ACTION_CREATORS;
};

const DEFAULT_ACTION_CREATORS = [
	displayNextTurnConfirmation,
	displayFinancialStatementNotSubmittedPopup,
	displayMandatoryProfitDistributionPopup,
	() => turnActions.fetchNextTurn(),
];

const afterConfirmedNextTurnActionCreators = DEFAULT_ACTION_CREATORS.slice(1);

const afterConfirmedDistributeProfitActionCreators = DEFAULT_ACTION_CREATORS.slice(2);

const afterConfirmedMandatoryProfitDistributionActionCreators = DEFAULT_ACTION_CREATORS.slice(3);

export default onStartNextTurnEpic;
